import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import ScreenLoader from "./ScreenLoader";
import { votersService } from "../services/VotersService";
import { changeLang } from "./Language/ChangeLang";
import { Button } from "primereact/button";


export default function ({ _delimitation, filterParams, setHideComponent, onChange,includeEligible }) {
    const [lazyState, setlazyState] = useState({
        first: 0,
        rows: 5,
        page: 0
    });
    var [data, setData] = useState([]);
    var [totalRecords, setTotalRecords] = useState([]);
    var [total, setTotal] = useState(0);
    var [selectedItems, setSelectedItems] = useState([]);
    var [loading, setLoading] = useState(false);
    var [refresh, setRefresh] = useState(false);
    var [canCheckEligible, setCanCheckEligible] = useState(false);
    var onPageChange = (event) => {
        setlazyState(event);
    };
    var [query, setQuery] = useState({
        DelimitationID: null,
        DelimitationLevelID: null,
        PageIndex: null,
        PageSize: null
    })
    var [delimitation, setDelimitation] = useState({ ...filterParams });


    useEffect(() => {
        // newParams["has_id_number"] = false;

        if (Object.keys(filterParams).length > 0) {
            setLoading(true);
            if (filterParams["has_id_number"]) {
                setCanCheckEligible(true)
                votersService
                    .getByIDNumber(filterParams["idNumber"])
                    .then((_data) => {
                        console.log(_data)
                        setLoading(false);
                        if (JSON.stringify(_data).trim().length > 4) {
                            setData([_data]);
                            setTotalRecords(1);
                            setTotal(1)
                        } else {
                            setData([]);
                            setTotalRecords(1);
                            setTotal(1)
                        }


                    })
                    .catch((error) => {
                        console.error("Error fetching application:", error);
                        setLoading(false);
                    });
            } else {
                setCanCheckEligible(false)
                delete delimitation["has_id_number"];
                votersService.getAllVoters({
                    ...delimitation,
                    // Name:"Addison",
                    PageIndex: lazyState.page + 1,
                    PageSize: (lazyState.rows) * (lazyState.page + 1),
                    IncludeInneligibleVoters:includeEligible
                })
                    .then((_data) => {
                        setLoading(false);
                        setData([..._data.voters]);
                        setTotalRecords(data.count);
                        setTotal(_data.count)
                    })
                    .catch((error) => {
                        console.error("Error fetching application:", error);
                        setLoading(false);
                    });

            }
        }

    }, [lazyState, refresh, delimitation, filterParams]);

    return (<>
        {/* <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center my-2">
            {header !== null && <h5>{header} - {total} </h5>}
        </div> */}
        <ScreenLoader visible={loading} />
        {/* <UserDelimitation midGridBlock={"6 lg:col-3"} isReport={true} onDelimitationChanged={(e) => {
            setDelimitation(e)
            setlazyState({
                first: 0,
                rows: 10,
                page: 0
            })
        }} isPoliticalParty={true} politicalDelimitation={{}} /> */}

        <DataTable
            first={lazyState.first}
            size="small"
            scrollable={true}
            value={data}
            loading={loading}
            dataKey="applicationID"
            className="datatable-responsive"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            emptyMessage="No data found."
            resizableColumns
            columnResizeMode="expand"
            selectionMode="checkbox"
            // onSelectionChange={(e) => setSelectedItems(e.value)}
            // selection={selectedItems}
            selectionPageOnly={true}
            rows={lazyState.rows}
            rowsPerPageOptions={[10, 20, 50]}
            totalRecords={totalRecords}
            onPage={onPageChange}
            paginator={true}
        // paginatorRight={paginatorRight}
        // paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        // paginatorRight={paginatorRight}
        >

            <Column field="firstname" header="Firstname" sortable></Column>
            <Column field="surname" header="Surname" sortable></Column>
            {/* <Column field="registrationNumber" header="Registration No." sortable></Column> */}
            <Column field="idNumber" header="ID Number" sortable></Column>

            <Column field="village.district" header={changeLang.get("national_delimitation.district")} sortable></Column>
            {/* <Column field="village.registrationCentre" header={changeLang.get("national_delimitation.votingCentre")} sortable></Column>
            <Column field="village.name" header={changeLang.get("national_delimitation.village")} sortable></Column> */}
            <Column
                field="actions"
                header="Actions"
                body={(e) => (
                    <>
                        <Button
                            // disabled={isOnlyView}
                            onClick={() => {
                                setHideComponent(true)
                                console.log(e)

                                try {
                                    if (canCheckEligible) {
                                        var status = false
                                        if (e.eligibleStatus.toLowerCase().includes("y")) {
                                            status = true
                                        }
                                        onChange({
                                            eligible: status,
                                            ...e
                                        })
                                    } else {
                                        onChange({
                                            eligible: true,
                                            ...e
                                        })
                                    }
                                } catch (error) {

                                }

                            }}
                            style={{ textAlign: "center", width: "30px", height: "30px" }}
                            icon={"pi pi-plus"}
                            className="p-button-success p-button-rounded mr-2"
                            tooltip="Click to Open"
                        />
                    </>
                )}
            ></Column>
        </DataTable>
    </>)
}